import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-salon-management',
  templateUrl: './salon-management.component.html',
  styleUrls: ['./salon-management.component.css']
})
export class SalonManagementComponent implements OnInit {
  @Input() sucId = 1;
  @Input() servicios: any[] = [];
  @Input() productos: any[] = [];
  @Input() trabajadores: any[] = [];
  @Input() metodosPago: any[] = [];
  @Input() categoriasServicio: any[] = [];
  @Input() categoriasProducto: any[] = [];
  @Input() especialidades: any[] = [];
  @Input() roles: any[] = [];
  @Input() usuarios: any[] = [];
  @Input() clientes: any[] = [];
  @Output() changed = new EventEmitter<void>();

  section = 'clientes';
  busy = false;
  clienteSearch = '';

  cliente: any = {
    p_cli_id: 0,
    p_per_tipdoc: 'DNI',
    p_per_numdoc: '',
    p_per_nombres: '',
    p_per_apepat: '',
    p_per_apemat: '',
    p_per_celular: '',
    p_per_correo: '',
    p_per_direccion: ''
  };

  trabajador: any = {
    p_tra_id: 0,
    p_esp_id: 1,
    p_per_tipdoc: 'DNI',
    p_per_numdoc: '',
    p_per_nombres: '',
    p_per_apepat: '',
    p_per_apemat: '',
    p_per_celular: '',
    p_per_correo: '',
    p_tra_comision_base: 0
  };

  servicio: any = {
    p_csv_id: 1,
    p_ser_nombre: '',
    p_ser_precio: 0,
    p_ser_comision_pct: 0,
    p_ser_duracion_min: 45,
    p_ser_activo: 1
  };

  producto: any = {
    p_cat_id: 1,
    p_pro_nombre: '',
    p_pro_precio_compra: 0,
    p_pro_precio_venta: 0,
    p_pro_stock_actual: 0,
    p_pro_stock_min: 2,
    p_pro_activo: 1
  };

  usuario: any = {
    p_usu_id: 0,
    p_rol_id: 1,
    p_login: '',
    p_password: '',
    p_tipdoc: 'DNI',
    p_numdoc: '',
    p_apepat: '',
    p_apemat: '',
    p_nombres: '',
    p_celular: '',
    p_correo: ''
  };

  clienteTipDocFilter = 'TODOS';
  clientPage = 1;
  clientPageSize = 10;
  pageSizeOptions = [10, 25, 50, 100];

  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this.loadAuditoriaLogs();
  }

  get filteredClientes(): any[] {
    const q = String(this.clienteSearch || '').trim().toLowerCase();
    const tipDoc = String(this.clienteTipDocFilter || 'TODOS').toUpperCase();

    return (this.clientes || []).filter(c => {
      const matchTipDoc = tipDoc === 'TODOS' || String(c.per_tipdoc || 'DNI').toUpperCase() === tipDoc;
      if (!matchTipDoc) {
        return false;
      }
      if (!q) {
        return true;
      }
      const doc = String(c.per_numdoc || '').toLowerCase();
      const nom = String(c.per_nombres || '').toLowerCase();
      const pat = String(c.per_apepat || '').toLowerCase();
      const mat = String(c.per_apemat || '').toLowerCase();
      const cel = String(c.per_celular || '').toLowerCase();
      const cor = String(c.per_correo || '').toLowerCase();
      const dir = String(c.per_direccion || '').toLowerCase();
      return doc.includes(q) || nom.includes(q) || pat.includes(q) || mat.includes(q) || cel.includes(q) || cor.includes(q) || dir.includes(q);
    });
  }

  get totalClientPages(): number {
    return Math.ceil(this.filteredClientes.length / this.clientPageSize) || 1;
  }

  get paginatedClientes(): any[] {
    const start = (this.clientPage - 1) * this.clientPageSize;
    return this.filteredClientes.slice(start, start + this.clientPageSize);
  }

  get clientStartIndex(): number {
    return this.filteredClientes.length ? (this.clientPage - 1) * this.clientPageSize + 1 : 0;
  }

  get clientEndIndex(): number {
    return Math.min(this.clientPage * this.clientPageSize, this.filteredClientes.length);
  }

  setClientPage(page: number): void {
    if (page >= 1 && page <= this.totalClientPages) {
      this.clientPage = page;
    }
  }

  onFilterChange(): void {
    this.clientPage = 1;
  }

  saveClient(): void {
    if (!this.cliente.p_per_nombres || !this.cliente.p_per_nombres.trim()) {
      swal.fire('Dato requerido', 'Ingresa los nombres del cliente.', 'warning');
      return;
    }

    const doc = String(this.cliente.p_per_numdoc || '').trim();
    if (doc) {
      const duplicate = (this.clientes || []).find(c =>
        String(c.per_numdoc || '').trim() === doc &&
        (!this.cliente.p_cli_id || Number(c.cli_id) !== Number(this.cliente.p_cli_id))
      );

      if (duplicate) {
        const nombreDuplicado = `${duplicate.per_apepat || ''} ${duplicate.per_apemat || ''} ${duplicate.per_nombres || ''}`.trim();
        swal.fire({
          title: 'Documento ya registrado',
          text: `El documento ${doc} ya pertenece al cliente "${nombreDuplicado}". ¿Deseas cargar sus datos para editarlos?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, editar existente',
          cancelButtonText: 'Cancelar'
        }).then(res => {
          if (res.value) {
            this.editClient(duplicate);
          }
        });
        return;
      }
    }

    this.busy = true;
    this.api.salonClienteGra(this.cliente).subscribe(() => {
      this.resetClientForm();
      this.reloadClients();
      this.saved(this.cliente.p_cli_id ? 'Cliente actualizado' : 'Cliente registrado');
    }, (err) => this.fail(err));
  }

  editClient(item: any): void {
    this.section = 'clientes';
    this.cliente = {
      p_cli_id: item.cli_id,
      p_per_tipdoc: item.per_tipdoc || 'DNI',
      p_per_numdoc: item.per_numdoc || '',
      p_per_nombres: item.per_nombres || '',
      p_per_apepat: item.per_apepat || '',
      p_per_apemat: item.per_apemat || '',
      p_per_celular: item.per_celular || '',
      p_per_correo: item.per_correo || '',
      p_per_direccion: item.per_direccion || ''
    };
  }

  onDocumentChange(val: string): void {
    const doc = String(val || '').trim();
    if (!doc || this.cliente.p_cli_id) {
      return;
    }
    const found = (this.clientes || []).find(c => String(c.per_numdoc || '').trim() === doc);
    if (found) {
      this.editClient(found);
      return;
    }
    if (doc.length >= 8) {
      this.searchClientByDocument(doc);
    }
  }

  onDocumentBlur(): void {
    const doc = String(this.cliente.p_per_numdoc || '').trim();
    if (!doc || this.cliente.p_cli_id) {
      return;
    }
    const found = (this.clientes || []).find(c => String(c.per_numdoc || '').trim() === doc);
    if (found) {
      this.editClient(found);
      return;
    }
    this.searchClientByDocument(doc);
  }

  private searchClientByDocument(doc: string): void {
    if (!doc) {
      return;
    }
    this.api.salonClienteLis({ p_buscar: doc, p_activo: 1 }).subscribe((data: any) => {
      const rows = this.normalizeRows(data);
      const match = rows.find((c: any) => String(c.per_numdoc || '').trim() === doc) || (rows.length === 1 ? rows[0] : null);
      if (match) {
        this.editClient(match);
      }
    });
  }

  resetClientForm(): void {
    this.cliente = {
      p_cli_id: 0,
      p_per_tipdoc: 'DNI',
      p_per_numdoc: '',
      p_per_nombres: '',
      p_per_apepat: '',
      p_per_apemat: '',
      p_per_celular: '',
      p_per_correo: '',
      p_per_direccion: ''
    };
  }

  reloadClients(): void {
    this.api.salonClienteLis({ p_buscar: '', p_activo: 1 }).subscribe((data: any) => {
      this.clientes = this.normalizeRows(data);
    });
  }

  editWorker(item: any): void {
    this.section = 'trabajadores';
    const defaultEsp = (this.especialidades && this.especialidades[0]) ? this.especialidades[0].id : 1;
    const espId = item.esp_id ? Number(item.esp_id) : defaultEsp;
    this.trabajador = {
      p_tra_id: Number(item.tra_id),
      p_esp_id: espId,
      p_per_tipdoc: item.per_tipdoc || 'DNI',
      p_per_numdoc: item.per_numdoc || '',
      p_per_nombres: item.per_nombres || '',
      p_per_apepat: item.per_apepat || '',
      p_per_apemat: item.per_apemat || '',
      p_per_celular: item.per_celular || '',
      p_per_correo: item.per_correo || '',
      p_tra_comision_base: item.tra_comision_base ? Number(item.tra_comision_base) : 0
    };

    try {
      const el = document.getElementById('worker-form-panel');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (e) {
    }
  }

  cancelWorkerEdit(): void {
    this.resetWorkerForm();
  }

  resetWorkerForm(): void {
    const defaultEsp = (this.especialidades && this.especialidades[0]) ? this.especialidades[0].id : 1;
    this.trabajador = {
      p_tra_id: 0,
      p_esp_id: defaultEsp,
      p_per_tipdoc: 'DNI',
      p_per_numdoc: '',
      p_per_nombres: '',
      p_per_apepat: '',
      p_per_apemat: '',
      p_per_celular: '',
      p_per_correo: '',
      p_tra_comision_base: 0
    };
  }

  saveWorker(): void {
    if (!this.trabajador.p_per_nombres || !this.trabajador.p_per_nombres.trim()) {
      swal.fire('Dato requerido', 'Ingresa los nombres del trabajador.', 'warning');
      return;
    }

    const isEdit = Number(this.trabajador.p_tra_id) > 0;
    const nombreCompleto = `${this.trabajador.p_per_apepat || ''} ${this.trabajador.p_per_nombres}`.trim();

    if (isEdit) {
      swal.fire({
        title: '¿Confirmar actualización de trabajador?',
        html: `
          <div style="text-align: left; margin: 10px 0;">
            <p style="margin-bottom: 10px; font-size: 14px; color: #475467;">
              Se actualizarán los datos de <strong>${nombreCompleto}</strong>. Este cambio quedará registrado en la auditoría con tu usuario y la hora actual.
            </p>
            <label style="font-size: 13px; font-weight: 700; color: #344054;">Motivo del ajuste (opcional):</label>
            <input id="swal-worker-motivo" class="swal2-input" style="margin: 6px 0 0; width: 100%; font-size: 14px;" placeholder="Ej. Corrección de DNI, cambio de número o especialidad...">
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, aplicar y auditar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#123a5f',
        preConfirm: () => {
          const input = document.getElementById('swal-worker-motivo') as HTMLInputElement;
          return input ? input.value : '';
        }
      }).then((res: any) => {
        if (res.value !== undefined && (res.isConfirmed || res.value !== false)) {
          const motivo = res.value || 'Actualización de datos de trabajador';
          this.executeSaveWorker(motivo);
        }
      });
    } else {
      this.executeSaveWorker('Registro de nuevo trabajador');
    }
  }

  private executeSaveWorker(motivo: string): void {
    const isEdit = Number(this.trabajador.p_tra_id) > 0;
    this.busy = true;

    const payload = Object.assign({}, this.trabajador, {
      p_tra_id: Number(this.trabajador.p_tra_id || 0),
      p_suc_id: this.sucId,
      p_usu_id: this.currentUserId(),
      p_motivo: motivo
    });

    this.api.salonTrabajadorGra(payload).subscribe(() => {
      this.resetWorkerForm();
      this.reloadWorkers();
      this.loadAuditoriaLogs();
      this.saved(isEdit ? 'Trabajador actualizado y auditado correctamente' : 'Trabajador registrado');
    }, (err) => this.fail(err));
  }

  toggleWorker(item: any): void {
    const nuevoEstado = Number(item.tra_activo) === 1 ? 0 : 1;
    const accionTexto = nuevoEstado === 1 ? 'activar' : 'desactivar';
    const nombre = `${item.per_apepat || ''} ${item.per_nombres || ''}`.trim();

    swal.fire({
      title: `¿Deseas ${accionTexto} a este trabajador?`,
      text: `${nombre} pasará a estar ${nuevoEstado === 1 ? 'ACTIVO (disponible para servicios y ventas)' : 'INACTIVO (no aparecerá en opciones de asignación)'}. Este cambio quedará registrado en auditoría.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: `Sí, ${accionTexto}`,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: nuevoEstado === 1 ? '#16a34a' : '#dc2626'
    }).then((res: any) => {
      if (res.value || res.isConfirmed) {
        this.busy = true;
        this.api.salonTrabajadorEstado({
          p_tra_id: item.tra_id,
          p_activo: nuevoEstado,
          p_usu_id: this.currentUserId(),
          p_motivo: `Cambio de estado a ${nuevoEstado === 1 ? 'ACTIVO' : 'INACTIVO'}`
        }).subscribe(() => {
          this.reloadWorkers();
          this.loadAuditoriaLogs();
          this.saved(`Trabajador ${nuevoEstado === 1 ? 'activado' : 'desactivado'} correctamente`);
        }, (err) => this.fail(err));
      }
    });
  }

  // Auditoría individual por trabajador
  workerAuditModalOpen = false;
  selectedWorkerForAudit: any = null;
  selectedWorkerLogs: any[] = [];
  loadingWorkerAudit = false;

  getWorkerLastAudit(worker: any): any {
    if (!worker || !worker.tra_id || !this.auditoriaLogs || !this.auditoriaLogs.length) {
      return null;
    }
    const regId = 'TRABAJADOR-' + worker.tra_id;
    for (let i = 0; i < this.auditoriaLogs.length; i++) {
      const l = this.auditoriaLogs[i];
      if (l && (l.aud_registro === regId || (l.aud_tabla === 'trabajadores' && String(l.aud_detalle || '').includes('#' + worker.tra_id)))) {
        return l;
      }
    }
    return null;
  }

  openWorkerAuditHistory(worker: any): void {
    this.selectedWorkerForAudit = worker;
    this.workerAuditModalOpen = true;
    this.loadingWorkerAudit = true;
    this.selectedWorkerLogs = [];

    this.api.salonAuditoriaLis({ p_fecini: null, p_fecfin: null, p_usu_id: 0 }).subscribe((data: any) => {
      this.loadingWorkerAudit = false;
      const allLogs = this.normalizeRows(data);
      this.auditoriaLogs = allLogs;
      const regId = 'TRABAJADOR-' + worker.tra_id;
      this.selectedWorkerLogs = allLogs.filter((l: any) => {
        return l && (l.aud_registro === regId || (l.aud_tabla === 'trabajadores' && String(l.aud_detalle || '').includes('#' + worker.tra_id)));
      });
    }, () => {
      this.loadingWorkerAudit = false;
      const regId = 'TRABAJADOR-' + worker.tra_id;
      this.selectedWorkerLogs = (this.auditoriaLogs || []).filter((l: any) => {
        return l && (l.aud_registro === regId || (l.aud_tabla === 'trabajadores' && String(l.aud_detalle || '').includes('#' + worker.tra_id)));
      });
    });
  }

  closeWorkerAuditHistory(): void {
    this.workerAuditModalOpen = false;
    this.selectedWorkerForAudit = null;
    this.selectedWorkerLogs = [];
  }

  saveService(): void {
    if (!this.servicio.p_ser_nombre || Number(this.servicio.p_ser_precio) <= 0) {
      swal.fire('Datos requeridos', 'Completa nombre y precio del servicio.', 'warning');
      return;
    }
    this.busy = true;
    this.api.salonServicioGra(Object.assign({ p_ser_id: 0 }, this.servicio))
      .subscribe(() => this.saved('Servicio registrado'), (err) => this.fail(err));
  }

  saveProduct(): void {
    if (!this.producto.p_pro_nombre || Number(this.producto.p_pro_precio_venta) <= 0) {
      swal.fire('Datos requeridos', 'Completa nombre y precio de venta del producto.', 'warning');
      return;
    }
    this.busy = true;
    this.api.salonProductoGra(Object.assign({ p_pro_id: 0 }, this.producto))
      .subscribe(() => this.saved('Producto registrado'), (err) => this.fail(err));
  }

  saveUser(): void {
    if (!this.usuario.p_login || !this.usuario.p_apepat || !this.usuario.p_nombres) {
      swal.fire('Datos requeridos', 'Completa usuario, apellido paterno y nombres.', 'warning');
      return;
    }
    this.busy = true;
    this.api.salonUsuarioGra(this.usuario)
      .subscribe(() => {
        this.usuario = Object.assign({}, this.usuario, {
          p_usu_id: 0,
          p_login: '',
          p_password: '',
          p_numdoc: '',
          p_apepat: '',
          p_apemat: '',
          p_nombres: '',
          p_celular: '',
          p_correo: ''
        });
        this.saved('Usuario registrado');
      }, (err) => this.fail(err));
  }

  editUser(item: any): void {
    this.section = 'usuarios';
    this.usuario = {
      p_usu_id: item.usu_id,
      p_rol_id: item.rol_id,
      p_login: item.usu_login,
      p_password: '',
      p_tipdoc: item.per_tipdoc || 'DNI',
      p_numdoc: item.per_numdoc || '',
      p_apepat: item.per_apepat || '',
      p_apemat: item.per_apemat || '',
      p_nombres: item.per_nombres || '',
      p_celular: item.per_celular || '',
      p_correo: item.per_correo || ''
    };
  }

  toggleUser(item: any): void {
    this.busy = true;
    this.api.salonUsuarioEstado({
      p_usu_id: item.usu_id,
      p_activo: Number(item.usu_activo) === 1 ? 0 : 1
    }).subscribe(() => this.saved('Estado actualizado'), (err) => this.fail(err));
  }

  private saved(message: string): void {
    this.busy = false;
    swal.fire('Listo', message, 'success');
    this.changed.emit();
  }

  private reloadWorkers(): void {
    this.api.salonTrabajadorLis({
      p_suc_id: this.sucId,
      p_activo: null
    }).subscribe((data: any) => {
      this.trabajadores = this.normalizeRows(data);
    });
  }



  private normalizeRows(data: any): any[] {
    if (Array.isArray(data)) {
      if (Array.isArray(data[0])) {
        return data[0];
      }
      return data;
    }
    return [];
  }

  // ==========================================================================
  // AUDITORÍA Y AJUSTES DE OPERACIONES POR FECHA
  // ==========================================================================
  auditSubTab: 'ajustes' | 'historial' = 'ajustes';
  auditDate: string = this.toDateInput(new Date());
  auditFecIni: string = this.toDateInput(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
  auditFecFin: string = this.toDateInput(new Date());
  auditUserFilter: number = 0;
  auditSearch: string = '';

  operacionesVentas: any[] = [];
  operacionesEgresos: any[] = [];
  operacionesIngresos: any[] = [];
  auditoriaLogs: any[] = [];
  loadingAudit = false;

  // Modal de modificación
  editModalOpen = false;
  editForm = {
    tipo: 'VENTA',
    registro_id: 0,
    monto_actual: 0,
    nuevo_monto: 0,
    fecha_actual: '',
    nueva_fecha: '',
    motivo: '',
    cliente_concepto: ''
  };

  auditPage = 1;
  auditPageSize = 10;

  get filteredAuditLogs(): any[] {
    const q = String(this.auditSearch || '').trim().toLowerCase();
    return (this.auditoriaLogs || []).filter(item => {
      if (!q) return true;
      const u = String(item.usuario_nombre || '').toLowerCase();
      const login = String(item.usuario_login || '').toLowerCase();
      const det = String(item.aud_detalle || '').toLowerCase();
      const mot = String(item.aud_motivo || '').toLowerCase();
      const reg = String(item.aud_registro || '').toLowerCase();
      return u.includes(q) || login.includes(q) || det.includes(q) || mot.includes(q) || reg.includes(q);
    });
  }

  get paginatedAuditLogs(): any[] {
    const start = (this.auditPage - 1) * this.auditPageSize;
    return this.filteredAuditLogs.slice(start, start + this.auditPageSize);
  }

  get totalAuditPages(): number {
    return Math.ceil(this.filteredAuditLogs.length / this.auditPageSize) || 1;
  }

  get auditStartIndex(): number {
    return this.filteredAuditLogs.length ? (this.auditPage - 1) * this.auditPageSize + 1 : 0;
  }

  get auditEndIndex(): number {
    return Math.min(this.auditPage * this.auditPageSize, this.filteredAuditLogs.length);
  }

  get totalVentasDia(): number {
    return (this.operacionesVentas || []).reduce((acc, v) => acc + Number(v.monto || 0), 0);
  }

  get totalEgresosDia(): number {
    return (this.operacionesEgresos || []).reduce((acc, e) => acc + Number(e.monto || 0), 0);
  }

  get totalIngresosDirectosDia(): number {
    return (this.operacionesIngresos || []).reduce((acc, i) => acc + Number(i.monto || 0), 0);
  }

  setAuditSection(): void {
    this.section = 'auditoria';
    this.loadAuditData();
  }

  loadAuditData(): void {
    if (this.auditSubTab === 'ajustes') {
      this.loadOperacionesPorFecha();
    } else {
      this.loadAuditoriaLogs();
    }
  }

  loadOperacionesPorFecha(): void {
    this.loadingAudit = true;
    this.api.salonOperacionesLis({
      p_suc_id: this.sucId,
      p_fecha: this.auditDate
    }).subscribe((res: any) => {
      this.loadingAudit = false;
      this.operacionesVentas = res && res.ventas ? res.ventas : [];
      this.operacionesEgresos = res && res.egresos ? res.egresos : [];
      this.operacionesIngresos = res && res.ingresos ? res.ingresos : [];
    }, (err) => {
      this.loadingAudit = false;
      this.fail(err);
    });
  }

  loadAuditoriaLogs(): void {
    this.loadingAudit = true;
    this.api.salonAuditoriaLis({
      p_fecini: this.auditFecIni,
      p_fecfin: this.auditFecFin,
      p_usu_id: this.auditUserFilter || 0
    }).subscribe((data: any) => {
      this.loadingAudit = false;
      this.auditoriaLogs = this.normalizeRows(data);
      this.auditPage = 1;
    }, (err) => {
      this.loadingAudit = false;
      this.fail(err);
    });
  }

  private defaultMetodosPago = [
    { id: 1, nombre: 'EFECTIVO' },
    { id: 2, nombre: 'YAPE' },
    { id: 3, nombre: 'PLIN' },
    { id: 4, nombre: 'TARJETA' },
    { id: 5, nombre: 'TRANSFERENCIA' }
  ];

  get activeMetodosPago(): any[] {
    const list = this.metodosPago && this.metodosPago.length ? this.metodosPago : this.defaultMetodosPago;
    return list.map((m: any) => ({
      id: Number(m.id || m.mpa_id || 1),
      nombre: String(m.nombre || m.mpa_nombre || 'EFECTIVO'),
      mpa_id: Number(m.id || m.mpa_id || 1),
      mpa_nombre: String(m.nombre || m.mpa_nombre || 'EFECTIVO')
    }));
  }

  // Estado del editor POS en modal
  posCart: any[] = [];
  posPagos: any[] = [];
  loadingPosDetails = false;
  selectedExtraItem = 0;
  extraItemType: 'SERVICIO' | 'PRODUCTO' = 'SERVICIO';

  get posTotal(): number {
    return (this.posCart || []).reduce((acc, it) => acc + (Number(it.cantidad || 1) * Number(it.precio || 0)), 0);
  }

  get posPagoTotal(): number {
    return (this.posPagos || []).reduce((acc, p) => acc + Number(p.monto || 0), 0);
  }

  get posPagoPendiente(): number {
    return Math.max(0, Number((this.posTotal - this.posPagoTotal).toFixed(2)));
  }

  changePosQty(item: any, delta: number): void {
    const next = Math.max(1, (Number(item.cantidad) || 1) + delta);
    item.cantidad = next;
    item.total = Number((item.cantidad * item.precio).toFixed(2));
  }

  changePosPrice(item: any, val: any): void {
    item.precio = Math.max(0, Number(val) || 0);
    item.total = Number((item.cantidad * item.precio).toFixed(2));
  }

  removePosItem(idx: number): void {
    this.posCart.splice(idx, 1);
  }

  addPosPago(): void {
    this.posPagos.push({
      mpa_id: Number(this.activeMetodosPago[0] ? this.activeMetodosPago[0].id : 1),
      monto: this.posPagoPendiente > 0 ? this.posPagoPendiente : 0
    });
  }

  removePosPago(idx: number): void {
    this.posPagos.splice(idx, 1);
  }

  fillSinglePosPago(): void {
    if (!this.posPagos.length) {
      this.posPagos = [{
        mpa_id: Number(this.activeMetodosPago[0] ? this.activeMetodosPago[0].id : 1),
        monto: this.posTotal
      }];
    } else {
      this.posPagos[0].monto = this.posTotal;
      this.posPagos[0].mpa_id = Number(this.posPagos[0].mpa_id || 1);
      this.posPagos = [this.posPagos[0]];
    }
  }

  addExtraItemToPos(): void {
    if (!this.selectedExtraItem) return;

    if (this.extraItemType === 'SERVICIO') {
      const s = (this.servicios || []).find(it => Number(it.ser_id) === Number(this.selectedExtraItem));
      if (s) {
        this.posCart.push({
          vde_id: 0,
          tip_id: 1,
          tipo: 'SERVICIO',
          ser_id: s.ser_id,
          pro_id: null,
          tra_id: this.trabajadores[0] ? this.trabajadores[0].tra_id : null,
          nombre: s.ser_nombre,
          trabajador: this.trabajadores[0] ? `${this.trabajadores[0].per_apepat || ''} ${this.trabajadores[0].per_nombres || ''}`.trim() : '',
          cantidad: 1,
          precio: Number(s.ser_precio || 0),
          total: Number(s.ser_precio || 0)
        });
      }
    } else {
      const p = (this.productos || []).find(it => Number(it.pro_id) === Number(this.selectedExtraItem));
      if (p) {
        this.posCart.push({
          vde_id: 0,
          tip_id: 2,
          tipo: 'PRODUCTO',
          ser_id: null,
          pro_id: p.pro_id,
          tra_id: this.trabajadores[0] ? this.trabajadores[0].tra_id : null,
          nombre: p.pro_nombre,
          trabajador: this.trabajadores[0] ? `${this.trabajadores[0].per_apepat || ''} ${this.trabajadores[0].per_nombres || ''}`.trim() : '',
          cantidad: 1,
          precio: Number(p.pro_precio_venta || 0),
          total: Number(p.pro_precio_venta || 0)
        });
      }
    }
    this.selectedExtraItem = 0;
  }

  openEditModal(item: any, tipo: 'VENTA' | 'EGRESO' | 'INGRESO'): void {
    this.editForm = {
      tipo: tipo,
      registro_id: item.id || (tipo === 'VENTA' ? item.ven_id : item.cam_id),
      monto_actual: Number(item.monto || 0),
      nuevo_monto: Number(item.monto || 0),
      fecha_actual: item.fecha_hora || '',
      nueva_fecha: item.fecha_hora ? item.fecha_hora.replace(' ', 'T') : '',
      motivo: '',
      cliente_concepto: tipo === 'VENTA'
        ? `${item.cliente || 'Cliente'} (${item.items || 'Items'})`
        : (tipo === 'EGRESO' ? (item.motivo_descripcion || 'Egreso de caja') : (item.motivo_descripcion || 'Ingreso directo a caja'))
    };

    if (tipo === 'VENTA') {
      this.loadingPosDetails = true;
      this.posCart = [];
      this.posPagos = [];
      this.editModalOpen = true;

      this.api.salonVentaDetalleSel({ p_ven_id: this.editForm.registro_id }).subscribe((res: any) => {
        this.loadingPosDetails = false;
        this.posCart = (res && res.items ? res.items : []).map((it: any) => ({
          vde_id: it.vde_id,
          tip_id: it.tip_id || 1,
          tipo: it.tipo || 'SERVICIO',
          ser_id: it.ser_id,
          pro_id: it.pro_id,
          tra_id: it.tra_id,
          nombre: it.nombre,
          trabajador: it.trabajador || '',
          cantidad: Number(it.cantidad || 1),
          precio: Number(it.precio || 0),
          total: Number(it.total || 0)
        }));

        this.posPagos = (res && res.pagos ? res.pagos : []).map((p: any) => ({
          vpa_id: p.vpa_id,
          mpa_id: Number(p.mpa_id || p.id || 1),
          monto: Number(p.monto || 0)
        }));

        if (!this.posPagos.length) {
          this.posPagos = [{
            mpa_id: Number(this.activeMetodosPago[0] ? this.activeMetodosPago[0].id : 1),
            monto: this.posTotal
          }];
        }
      }, (err) => {
        this.loadingPosDetails = false;
        this.fail(err);
      });
    } else {
      this.editModalOpen = true;
    }
  }

  closeEditModal(): void {
    this.editModalOpen = false;
    this.posCart = [];
    this.posPagos = [];
  }

  submitEditOperation(): void {
    if (!this.editForm.motivo || this.editForm.motivo.trim().length < 3) {
      swal.fire('Motivo requerido', 'Debes ingresar una justificación o motivo para la auditoría (mínimo 3 caracteres).', 'warning');
      return;
    }

    const payloadNuevaFecha = this.editForm.nueva_fecha
      ? this.editForm.nueva_fecha.replace('T', ' ')
      : null;

    if (this.editForm.tipo === 'VENTA') {
      if (!this.posCart.length) {
        swal.fire('Items requeridos', 'La venta debe contener al menos un item (servicio o producto).', 'warning');
        return;
      }

      if (this.posPagoPendiente > 0.01) {
        swal.fire('Pagos incompletos', `Falta cubrir S/ ${this.posPagoPendiente.toFixed(2)} en los métodos de pago. Presiona "Completar" o agrega un pago.`, 'warning');
        return;
      }

      swal.fire({
        title: '¿Confirmar modificación de venta?',
        text: `Se actualizarán los ${this.posCart.length} items de la venta #${this.editForm.registro_id}. Monto anterior: S/ ${this.editForm.monto_actual.toFixed(2)} -> Nuevo total: S/ ${this.posTotal.toFixed(2)}. Este cambio quedará registrado en la auditoría con tu usuario y la hora actual.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, aplicar y auditar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#123a5f'
      }).then((res: any) => {
        if (res.value || res.isConfirmed) {
          this.busy = true;
          this.api.salonVentaModificarPos({
            p_ven_id: this.editForm.registro_id,
            p_usu_id: this.currentUserId(),
            p_motivo: this.editForm.motivo.trim(),
            p_nueva_fecha: payloadNuevaFecha,
            items: this.posCart,
            pagos: this.posPagos.map((p: any) => ({
              vpa_id: p.vpa_id,
              mpa_id: Number(p.mpa_id || 1),
              monto: Number(p.monto || 0)
            }))
          }).subscribe(() => {
            this.busy = false;
            this.closeEditModal();
            this.saved('Venta actualizada y auditada correctamente');
            this.loadOperacionesPorFecha();
          }, (err) => this.fail(err));
        }
      });

    } else if (this.editForm.tipo === 'INGRESO') {
      if (Number(this.editForm.nuevo_monto) <= 0) {
        swal.fire('Monto inválido', 'El monto debe ser mayor a 0.', 'warning');
        return;
      }

      swal.fire({
        title: '¿Confirmar modificación de ingreso?',
        text: `Se cambiará el ingreso #${this.editForm.registro_id} de S/ ${this.editForm.monto_actual.toFixed(2)} a S/ ${Number(this.editForm.nuevo_monto).toFixed(2)}. Este cambio quedará registrado en la auditoría con tu usuario y la hora actual.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, aplicar y auditar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#059669'
      }).then((res: any) => {
        if (res.value || res.isConfirmed) {
          this.busy = true;
          this.api.salonOperacionModificar({
            p_tipo: 'INGRESO',
            p_registro_id: this.editForm.registro_id,
            p_nuevo_monto: this.editForm.nuevo_monto,
            p_nueva_fecha: payloadNuevaFecha,
            p_usu_id: this.currentUserId(),
            p_motivo: this.editForm.motivo.trim()
          }).subscribe(() => {
            this.busy = false;
            this.closeEditModal();
            this.saved('Ingreso directo actualizado y auditado correctamente');
            this.loadOperacionesPorFecha();
          }, (err) => this.fail(err));
        }
      });

    } else {
      // EGRESO
      if (Number(this.editForm.nuevo_monto) < 0) {
        swal.fire('Monto inválido', 'El monto no puede ser negativo.', 'warning');
        return;
      }

      swal.fire({
        title: '¿Confirmar modificación de egreso?',
        text: `Se cambiará el egreso #${this.editForm.registro_id} de S/ ${this.editForm.monto_actual.toFixed(2)} a S/ ${Number(this.editForm.nuevo_monto).toFixed(2)}. Este cambio quedará registrado en la auditoría con tu usuario y la hora actual.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, aplicar y auditar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#123a5f'
      }).then((res: any) => {
        if (res.value || res.isConfirmed) {
          this.busy = true;
          this.api.salonOperacionModificar({
            p_tipo: 'EGRESO',
            p_registro_id: this.editForm.registro_id,
            p_nuevo_monto: this.editForm.nuevo_monto,
            p_nueva_fecha: payloadNuevaFecha,
            p_usu_id: this.currentUserId(),
            p_motivo: this.editForm.motivo.trim()
          }).subscribe(() => {
            this.busy = false;
            this.closeEditModal();
            this.saved('Egreso actualizado y auditado correctamente');
            this.loadOperacionesPorFecha();
          }, (err) => this.fail(err));
        }
      });
    }
  }

  private currentUserId(): number {
    return Number(sessionStorage.getItem('usu_id') || localStorage.getItem('usu_id') || 1);
  }

  private toDateInput(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  private fail(err: any): void {
    this.busy = false;
    const message = err && err.error && err.error.error ? err.error.error : 'No se pudo procesar la solicitud';
    swal.fire('Atención', message, 'error');
  }
}
